/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrDateTimeFormatSpecifier } from './igr-date-time-format-specifier';
import { DateTimeFormatSpecifier } from './DateTimeFormatSpecifier';
import { TypeRegistrar } from './type';
var IgrDateTimeFormatSpecifierModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrDateTimeFormatSpecifierModule() {
    }
    IgrDateTimeFormatSpecifierModule.register = function () {
        TypeRegistrar.registerCons("IgrDateTimeFormatSpecifier", IgrDateTimeFormatSpecifier);
        TypeRegistrar.register("DateTimeFormatSpecifier", DateTimeFormatSpecifier.$type);
    };
    return IgrDateTimeFormatSpecifierModule;
}());
export { IgrDateTimeFormatSpecifierModule };
//# sourceMappingURL=igr-date-time-format-specifier-module.js.map
